import commonFetch from "./fetch";

type AuthInitResponse = {
  access_token: string;
};

const fetchAuthInit = (id : string): Promise<AuthInitResponse> => {
  let domain = document.location.href;
  if (window.location !== window.parent.location) {
    domain = document.referrer;
  }
  return commonFetch({
    url: 'auth/init',
    method: 'POST',
    fetchOptions: {
      body: JSON.stringify({
        id,
        domain,
      }),
    },
  });
}

type JourneyApplicationResponse = {
  journey_application_token: string;
};

const generateJourneyApplication = (
  journeyToken: string, 
  accessToken: string, 
  journeyData: any
  ): Promise<JourneyApplicationResponse> => {
  return commonFetch({
    url: `v1/journeys/${journeyToken}/applications?production=true`,
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'alloy-journey-application-sync': 'true'
    },
    method: 'POST',
    fetchOptions: {
      body: JSON.stringify({...journeyData})
    }
  });
}

export  {
  fetchAuthInit,
  generateJourneyApplication
}

